import { Vector3 } from 'three';

export type UserInteractionState = ReturnType<typeof user_interaction_state_provider>;

export const user_interaction_state_provider = () => ({
    /** Marks the fact that the next drag step taken will be the first one. */
    in_first_drag_step: true,
    draggable_object_was_clicked: false,
    manipulator_object_was_clicked: false,
    right_mouse_button_is_pressed: false,
    middle_mouse_button_is_pressed: false,
    edge_tangent_manipulators_are_shown: false,
    adding_edge_endpoints_status: false,
    edge_first_vertex_added: false,
    showing_sketches: false,
    axes_initialized: false,
    showing_reference_stl_vertices: false,
    rigid_move_manipulator_shown_after_copy_body: false,
    camera_still_moving: false,
    live_fairing: false,
    //smoothen_edges_post_drag: 0,
    converting_reference_to_phi: false,
    moving_coordinates_visible: false,
    selected_coordinates_visible: false,
    tangency_coordinates_visible: false,
    drag_step_count: 0,

    /** Flag for whether the user has moved clipping planes in position yet. */
    clipping_has_been_set: false,

    /** The target point where the camera is looking, and around which the camera is expected to rotate */
    camera_target_point: null as null | Vector3,

    /** String with name of selected clipping plane */
    clipping_plane_selected: '',
    brush_grabbing_objects: false,
    in_thicken_operation: false,

    /** Shader flag */
    shaders_on: false,
});
